import html2canvas from 'html2canvas'
import html2canvasFixSvg from 'html2canvas-fixsvg'
import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import EventEmitter, {
  DID_MOUNT_COMPONENT,
} from '../../../helpers/EventEmitter'
import { debounce } from '../../../helpers/common'
import { CLASS_HIDE_TABLE_PDF } from '../../../utils/common'
import {
  HEIGHT_PDF_LANSCAPE_WITHOUT_PADDING,
  HEIGHT_PDF_PORTRAIT_WITHOUT_PADDING,
  MARGIN_BOTTOM_TITLE_PANEL,
  MARGIN_TOP_TITLE_PANEL,
} from '../constant'
import { cloneNodeIncludeContent, getPdfHeightImage } from '../helper'

const convertToImg = (el, isFixSvg, callback) => {
  const { width: widthCut, height: heightCut } = el.getBoundingClientRect()
  const ratio = 2

  const configCanvas = {
    allowTaint: true,
    useCORS: true,
    removeContainer: true,
    logging: false,
    scale: ratio,
    width: widthCut,
    height: heightCut,
    onclone: (document) => {
      Array.from(document.children[0].querySelectorAll('*')).forEach((e) => {
        if (e.tagName !== 'I' && e.parentNode?.tagName !== 'I') {
          e.setAttribute(
            'style',
            [
              'font-family: sans-serif !important',
              e.getAttribute('style') || '',
            ].join(';'),
          )
        } else {
          e.setAttribute(
            'style',
            [
              'font-family: fiingate !important',
              e.getAttribute('style') || '',
            ].join(';'),
          )
        }
      })
    },
  }

  const htmlToCanvas = isFixSvg ? html2canvasFixSvg : html2canvas

  htmlToCanvas(el, configCanvas).then((canvas) => {
    document.body.removeChild(el)
    const canvasExport = document.createElement('canvas')
    const contextExport = canvasExport.getContext('2d')
    canvasExport.width = widthCut * ratio
    canvasExport.height = heightCut * ratio
    contextExport.fillRect(0, 0, canvasExport.width, canvasExport.height)
    contextExport.drawImage(canvas, 0, 0)
    document.body.appendChild(canvasExport)
    const data = canvasExport.toDataURL('image/jpg')
    document.body.removeChild(canvasExport)
    callback({ data, width: widthCut, height: heightCut })
  })
}

const getMaxRowSpanTr = (tr) => {
  return Array.from(tr.querySelectorAll('td') || []).reduce(
    (maxRowSpan, td) => Math.max(maxRowSpan, td.rowSpan || 1),
    1,
  )
}

const getGroupTr = (trEls) => {
  let nextIndexGroup = 0
  const groupTrEls = []
  for (let i = 0; i < trEls.length; i++) {
    if (i < nextIndexGroup) {
      continue
    }
    const tr = trEls[i]
    const maxRowSpan = getMaxRowSpanTr(tr)
    const newGroup = []
    for (let k = i; k < i + maxRowSpan; k++) {
      if (trEls[k]) {
        newGroup.push(trEls[k])
      }
    }
    groupTrEls.push(newGroup)
    nextIndexGroup = i + maxRowSpan
  }
  return groupTrEls
}

const appendGroupTr = (parent, groupTr) => {
  groupTr.forEach((tr) => parent.appendChild(tr))
}

const removeGroupTr = (parent, groupTr) => {
  groupTr.forEach((tr) => parent.removeChild(tr))
}

const removeOldContainer = (id) => {
  const oldContainer = document.getElementById(id)
  if (oldContainer) {
    document.body.removeChild(oldContainer)
  }
}

export const HtmlToImage = ({
  id,
  children,
  onDoneProcess,
  isWaitForMount = false,
  item = {},
  availableHeightPage = HEIGHT_PDF_PORTRAIT_WITHOUT_PADDING,
  currentTitlePanel,
  isTable,
  isFixSvg = false,
  isLandscape = false,
}) => {
  const [container] = useState(() => {
    removeOldContainer(id)

    const containerEl = document.createElement('div')
    const pxOutOfScreen = '-100000px'
    containerEl.id = id
    containerEl.style.position = 'absolute'
    containerEl.style.left = pxOutOfScreen
    containerEl.style.top = pxOutOfScreen

    document.body.appendChild(containerEl)
    return containerEl
  })

  if (isWaitForMount && !EventEmitter.events.DID_MOUNT_COMPONENT?.length) {
    const onMountRechart = debounce(() => {
      EventEmitter.unsubscribe(DID_MOUNT_COMPONENT, onMountRechart)
      convertToImage()
    }, 100)
    EventEmitter.subscribe(DID_MOUNT_COMPONENT, onMountRechart)
  }

  useEffect(() => {
    if (!isWaitForMount) {
      convertToImage()
    }
  }, [container])

  const convertToImage = () => {
    if (container) {
      if (!isTable) {
        const callback = (data) => {
          onDoneProcess({
            ...item,
            img: [data],
          })
        }
        convertToImg(container, isFixSvg, callback)
      } else {
        const trEl = Array.from(
          container.querySelector('tbody')?.querySelectorAll('tr') || [],
        )
        if (!trEl.length) {
          const callback = (data) => {
            onDoneProcess({
              ...item,
              img: [data],
            })
          }
          convertToImg(container, isFixSvg, callback)
        } else {
          const getNewContainer = () => {
            const newContainer = cloneNodeIncludeContent(container)
            newContainer.querySelector('tbody').innerHTML = ''
            const pxOutOfScreen = '-100000px'
            newContainer.style.position = 'absolute'
            newContainer.style.left = pxOutOfScreen
            newContainer.style.top = pxOutOfScreen
            document.body.appendChild(newContainer)
            return newContainer
          }
          const containers = []
          const imgTitlePanel = currentTitlePanel?.img?.[0]
          let heightTitle = 0
          if (imgTitlePanel) {
            heightTitle =
              getPdfHeightImage(
                imgTitlePanel.width,
                imgTitlePanel.height,
                isLandscape,
              ) +
              MARGIN_TOP_TITLE_PANEL +
              MARGIN_BOTTOM_TITLE_PANEL
          }
          let currentAvailableHeightPage = availableHeightPage - heightTitle
          let currentTable = getNewContainer()
          const groupTrEls = getGroupTr(trEl)
          groupTrEls.forEach((groupTr, index) => {
            let tbody = currentTable.querySelector('tbody')
            appendGroupTr(tbody, groupTr)
            const { width, height } = currentTable.getBoundingClientRect()
            if (
              getPdfHeightImage(width, height, isLandscape) >
              currentAvailableHeightPage
            ) {
              removeGroupTr(tbody, groupTr)
              if (index) {
                containers.push(currentTable)
              }
              currentAvailableHeightPage = isLandscape
                ? HEIGHT_PDF_LANSCAPE_WITHOUT_PADDING
                : HEIGHT_PDF_PORTRAIT_WITHOUT_PADDING
              currentTable = getNewContainer()
              appendGroupTr(currentTable.querySelector('tbody'), groupTr)
            }
            if (index === groupTrEls.length - 1) {
              containers.push(currentTable)
            }
          })

          const img = []
          const callback = (data) => {
            img.push(data)
            if (img.length === containers.length) {
              onDoneProcess({
                ...item,
                img,
              })
            }
          }

          containers.forEach((container, index) => {
            if (index) {
              Array.from(
                container.querySelectorAll(`.${CLASS_HIDE_TABLE_PDF}`) || [],
              ).forEach((el) => (el.style.display = 'none'))
            }
            convertToImg(container, isFixSvg, callback)
          })
        }
      }
    }
  }

  return <>{children && createPortal(children, container)}</>
}
